/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2023, Zumper
 */

export const isValidJson = (str: any) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
